import { render, staticRenderFns } from "./ApplicationFloatForm.vue?vue&type=template&id=b955b37a&scoped=true&"
import script from "./ApplicationFloatForm.vue?vue&type=script&lang=ts&"
export * from "./ApplicationFloatForm.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationFloatForm.vue?vue&type=style&index=0&id=b955b37a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b955b37a",
  null
  
)

export default component.exports